/**
 * Keyboard focus trap for the dialog.
 */
export function trapFocus(container, event) {
	if (event.key !== 'Tab') {
		return;
	}

	const focusable = container.querySelectorAll(
		'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
	);
	const list = Array.from(focusable).filter(
		(el) => !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true'
	);

	if (!list.length) {
		event.preventDefault();
		container.focus();
		return;
	}

	const first = list[0];
	const last = list[list.length - 1];

	if (event.shiftKey && document.activeElement === first) {
		event.preventDefault();
		last.focus();
	} else if (!event.shiftKey && document.activeElement === last) {
		event.preventDefault();
		first.focus();
	}
}
